// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"7a539b8d","895":"5ad41990","960":"849cb5e2","965":"0c901efe","985":"45945674"}[chunkId] + ".chunk.js";
};